import { render, staticRenderFns } from "./swpLoto.vue?vue&type=template&id=3928aed0"
import script from "./swpLoto.vue?vue&type=script&lang=js"
export * from "./swpLoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3928aed0')) {
      api.createRecord('3928aed0', component.options)
    } else {
      api.reload('3928aed0', component.options)
    }
    module.hot.accept("./swpLoto.vue?vue&type=template&id=3928aed0", function () {
      api.rerender('3928aed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpLoto.vue"
export default component.exports